var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('my-alert',{staticClass:"vue--alert",attrs:{"show":_vm.message !== '' && _vm.message !== null,"dismissible":true,"variant":"danger"},on:{"dismissed":_vm.clearError}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.message)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }